import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';

import { ContestDetailModel } from '../../../models/contest';
import { ArtistDetailModel } from '../../../models/artist';
import { ContestService } from '../../../services/contest.service';
import { AppUtils } from '../../../helpers';
import * as moment from 'moment';

@Component({
  selector: 'component-detail',
  templateUrl: './contest.detail.component.html'
})

export class ContestDetailComponent implements OnInit {
  @BlockUI('conatiner-contest-detail') blockUI: NgBlockUI;

  isModelLoaded = false;
  isContestClosed = false;
  contestId: number;
  contest: ContestDetailModel = new ContestDetailModel();
  artist: ArtistDetailModel = new ArtistDetailModel();
  canJoinContest = false;
  userAuthenticated = false;

  constructor(private _vcr: ViewContainerRef,
    private _route: ActivatedRoute,
    private _toastr: ToastsManager,
    private _contestService: ContestService,
    private _appUtils: AppUtils) {
    this._toastr.setRootViewContainerRef(this._vcr);
    this.userAuthenticated = this._appUtils.isUserAuthenticated();
    this._route.params.subscribe(params => {
      this.contestId = params['id'];
    });
    this.artist = new ArtistDetailModel();
  }

  ngOnInit() {
    this.getDetail();
    if (this.userAuthenticated) {
      this.canJoinContest = this._appUtils.getUserRole() === 'CREATOR';
    } else {
      this.canJoinContest = true;
    }
  }

  getDetail() {
    this.blockUI.start();
    this._contestService.getDetail(this.contestId)
      .subscribe(
        (data: any) => {
          this.blockUI.stop();

          Object.assign(this.contest, data);

          this.contest.contestBanner = data.contestBannerUrl
            ? data.contestBannerUrl
            : 'https://via.placeholder.com/1600X700.png?text=No%20Image';

          this.contest.contestThumbnail = data.contestThumbnailUrl
            ? data.contestThumbnailUrl
            : 'https://via.placeholder.com/270X200.png?text=No%20Image';

          if (moment().diff(this.contest.contestEndDate, 'hours') > 0) {
            this.contest.timeRemaining = 'Closed';
          } else {
            this.contest.timeRemaining
              = this._appUtils.getContestStartTimeline(this.contest.contestEndDate);
          }
          if (moment().diff(this.contest.contestEndDate, 'hours') > 0) {
            this.isContestClosed = true;
          } else {
            this.isContestClosed = false;
          }

          this.contest.contestEndDate = this._appUtils.getFormattedDate(this.contest.contestEndDate, 'MMM DD, YYYY');

          if (data.contestPrizings && data.contestPrizings.length !== 0) {
            const contestPrizing = data.contestPrizings[0];
            this.contest.prizing = contestPrizing.prizing;
            this.contest.prizingDescription = contestPrizing.description;
            this.contest.prizingAmount = contestPrizing.prizingAmount;
          }

          // bind contest artist detail
          this.artist.id = data.artist.id;
          this.artist.name = data.artist.name;
          this.artist.bio = data.artist.bio;
          this.artist.pressShot = data.artist.pressShot;
          this.artist.pressShotUrl = data.artist.pressShotUrl;
          this.artist.createdOn = this._appUtils.getFormattedDate(data.artist.createdOn, null);

          data.artist.links.map((item: any) => {
            switch (item.linkType) {
              case 1:
                this.artist.websiteUrl = item.link;
                break;
              case 2:
                this.artist.facebookUrl = item.link;
                break;
              case 3:
                this.artist.twitterUrl = item.link;
                break;
              case 4:
                this.artist.instagramUrl = item.link;
                break;
              case 5:
                this.artist.youTubeUrl = item.link;
                break;
              case 6:
                this.artist.linkedInUrl = item.link;
                break;
            }
          });

          this.isModelLoaded = true;

        },
        error => {
          this.blockUI.stop();
          this._appUtils.ProcessErrorResponse(this._toastr, error);
        }
      );
  }
}



// WEBPACK FOOTER //
// ./src/components/contest/detail/contest.detail.component.ts